import { render } from "./CategorySavePage.vue?vue&type=template&id=63276bb6"
import script from "./CategorySavePage.vue?vue&type=script&lang=js"
export * from "./CategorySavePage.vue?vue&type=script&lang=js"
script.render = render

export default script